import { motion } from "framer-motion";
import styled, { css } from "styled-components";

export const customStyles = {
  container: (base) => ({ ...base, flex: "1" }),
  control: (base, state) => ({
    ...base,
    minHeight: "45px",
    padding: "0",
    borderRadius: "4px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: state.isFocused ? "var(--primary-blue)" : "var(--primary-dark-200)",
    cursor: "text"
  }),
  multiValue: (base) => ({
    ...base,
    color: "var(--primary-white)",
    backgroundColor: "var(--primary-blue-400)",
    lineHeight: "normal",
    borderRadius: "3px",
    padding: "3px 6px 3px 10px;"
  }),
  multiValueLabel: (base) => ({
    ...base,
    fontFamily: "Rubik",
    fontSize: "var(--fs-base)",
    fontStyle: "normal",
    color: "var(--primary-white)",
    textOverflow: "ellipsis",
    fontWeight: "500"
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "var(--primary-blue-100, #acB6fe)",
    cursor: "pointer",
    "&:hover": {
      color: "var(--primary-white)",
      backgroundColor: "transparent"
    }
  }),
  indicatorsContainer: (base) => ({
    ...base,
    color: "var(--primary-blue-400)",
    cursor: "pointer"
  })
};

export const phoneNumberTestModal = css`
  background-color: rgba(21, 22, 51, 0.8);
  backdrop-filter: blur(2px);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div[id="modal-container"] {
    background-color: var(--primary-dark-600);
    border-radius: 20px;
    height: fit-content;
    width: 478px;
    border: none;
    overflow: hidden;
  }
`;

export const formButtonStyles = css`
  height: auto;
  min-height: 40px;
  border-radius: 3px;
  padding: 6px 10px;
  font-size: 0.857rem; // 12px

  &:disabled:hover {
    color: var(--primary-dark-300);
    background-color: var(--primary-white);
  }
`;

export const phoneIconStyles = css`
  ${formButtonStyles};
  flex-direction: row-reverse;
  flex: 2;
  max-width: 167.5px; // CategoryContainer width divided by 2 - minus the 15 gap
  gap: 2px;
  color: var(--primary-white);
  background-color: var(--primary-dark-600);

  &:disabled:hover {
    color: var(--primary-white);
    background-color: var(--primary-dark-600);
  }
`;

export const FloatingBtn = styled.div`
  flex: 3;
  max-width: 167.5px; // CategoryContainer width divided by 2 - minus the 15 gap
`;

export const CategoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: fit-content;
  width: 350px;
  flex-shrink: 0;
  background-color: var(--primary-white);
  border-radius: 8px;
  padding: 20px 15px;

  @media screen and (max-width: 960px) {
    margin-top: 20px;
    position: static;
  }
`;

export const Header = styled.h2`
  font-size: 1rem;
  line-height: 17px;
  font-family: Rubik;
  color: var(--primary-dark);
  font-weight: 500;
  font-style: normal;

  margin: 0 0 16px;
`;

export const ArrowContainer = styled.div`
  width: 0;
  overflow: hidden;
  opacity: 0;
  transition: width 0.3s ease-out, opacity 0.3s ease-out;
`;

export const CardText = styled.p`
  color: var(--primary-dark-300);
  font-family: Rubik;
  font-size: 1rem;
  line-height: normal;
  font-style: normal;
  font-weight: 500;
  transition: color 0.2s;
`;

export const Card = styled(motion.div)`
  display: flex;
  min-height: 40px;
  padding: 0 10px 0 15px;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  background-color: var(--primary-dark-50);
  transition: background-color 0.3s;
  border-radius: 5px;
  cursor: pointer;

  > svg[id="help-circle-icon"] {
    stroke-width: 2.5;
  }

  &:hover {
    ${ArrowContainer} {
      width: 20px;
      opacity: 1;
    }

    ${CardText} {
      color: var(--primary-blue);
    }
  }
`;

export const SearchBox = styled.div`
  margin-bottom: 30px;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: 100%;

  svg[id="search-md-icon"] {
    color: var(--primary-blue-400);
    height: 20px;
    width: 20px;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.04);
    }
  }
`;
